import { render, staticRenderFns } from "./BldrComponent.vue?vue&type=template&id=b2112620"
import script from "./BldrComponent.vue?vue&type=script&lang=js"
export * from "./BldrComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports